var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconComps07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#007DC3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "22.57,36.81 19.22,46 15.8,41.81 10.48,42.82 14,33.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "27.48,36.81 30.83,46 34.25,41.81 39.57,42.82 36.05,33.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "37.76,19.09 40.09,15.05 36.05,12.71 36.05,8.04 31.38,8.04 29.04,4 25,6.34 20.96,4 18.62,8.04  13.95,8.04 13.95,12.71 9.91,15.05 12.24,19.09 9.91,23.14 13.95,25.47 13.95,30.14 18.62,30.14 20.96,34.18 25,31.85 29.04,34.18  31.38,30.14 36.05,30.14 36.05,25.47 40.09,23.14  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.53,19.09c0,4.71-3.82,8.53-8.53,8.53s-8.53-3.82-8.53-8.53s3.82-8.53,8.53-8.53S33.53,14.38,33.53,19.09z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComps07);
export default __webpack_public_path__ + "static/media/icon-comps-07.2531f47982c54d0cf693c75f70045ab1.svg";
export { ForwardRef as ReactComponent };